import script from "./DetailsTickets.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailsTickets.vue?vue&type=script&setup=true&lang=js"

import "./DetailsTickets.vue?vue&type=style&index=0&id=3479bfb5&lang=css"

const __exports__ = script;

export default __exports__